import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "animate.css";
import "@harea/component/dist/main.css";
import "@harea/component/dist/index.css";
import "@harea/login/dist/main.css";
import "@harea/login/dist/index.css";
import "@harea/user-management/dist/main.css";
import "@harea/project/dist/main.css";
import "@harea/project/dist/index.css";
import "@harea/contract/dist/main.css";
// import "@harea/contract/dist/index.css";
// import "@harea/payslip/dist/main.css";
import "@harea/translation/dist/main.css";
import "@harea/notification/dist/main.css";
import "./index.css";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
